export enum ExperienceTotalType {
    NonBFI = 0,
    BFIRepaymentsOver5Years = 1,
    BFIRepaymentsLast5Years = 2,
}

export const ExperienceTotalTypeOptions = [
    {
        id: ExperienceTotalType.NonBFI,
        name: 'Non-BFI Experience',
    },
    {
        id: ExperienceTotalType.BFIRepaymentsOver5Years,
        name: 'BFI Repayments, over 5 years',
    },
    {
        id: ExperienceTotalType.BFIRepaymentsLast5Years,
        name: 'BFI Repayments, past 5 years',
    },
];
